import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormArray, FormControl, Form, FormBuilder, Validators } from '@angular/forms';



import {apiUrl}  from '../global';

import { ResponseApi } from '../response-api';
import { QuizService } from '../quiz.service';
import { SharedService } from '../shared.service';

function validateEmail(c: FormControl) {
  let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

  return EMAIL_REGEXP.test(c.value) ? null : {
    validateEmail: {
      valid: false
    }
  };
}

@Component({
  selector: 'login',
  templateUrl: 'quiz.component.html',
  styleUrls: ['quiz.component.css'],
})
export class QuizComponent implements OnInit {
  responseApis: ResponseApi[];
  loginAttempt: ResponseApi[];
  error: any;
  backgroundColor: string;
  fadeOutLoader: boolean;
  fadeOutLoaderLogin: boolean;
  logo: any;
  domainList: any;
  userListType: boolean;
  hasUserList: boolean;
  form: any;
  attemptToSubmit: boolean;
  showLoaderLogin: boolean;
  textError: string;
  identifierForServer: string;
  currentQuestion: any;
  previousQuestion: any;
  baseUrl: any;
  lengthOfQuiz: any;
  orderInQuiz:any;
  flagImage:any;
  hideme:boolean;

  slideIn: boolean;
  slideOut: boolean;

  slideInRight: boolean;
  slideOutRight: boolean;

  genericVal: any;
  nextQuestion: any;
  nextQuest: any;

  policyTitle:any;
  policyText:any;
  policy:boolean;

  instructionsTitle:any;
  instructionsText:any;
  instructions:boolean;

  hideFlag:boolean;

  showBigImageContainer:boolean;



  constructor(private router: Router, private quizService: QuizService, private route: ActivatedRoute, private sharedService: SharedService) {
    this.slideIn = false;
    this.slideOut = false;

    this.attemptToSubmit = true;

    this.fadeOutLoaderLogin = false;
    this.showLoaderLogin = false;

    this.textError = "";
    this.getUrl;
    this.currentQuestion = false;
    this.slideIn = false;
    this.slideOut = false;
    this.nextQuestion = false;

    this.hideme = false;
  }
  setBackgroundColor(backgroundColor: string):void{
    this.sharedService.setBackgroundColor(backgroundColor);
  }
  ngAfterViewChecked() {
    /*if(document.getElementById('bar-top') != null){
     document.getElementById('bar-top').scrollIntoView();
     }*/
    //document.getElementById('bar-top').scrollIntoView();
  }
  getBackgroundColor(){
    return this.sharedService.getVal('backgroundColor');
  }
  getUrl(url: string): void {
    if(localStorage.getItem('hash') != null){
      this.quizService
        .getUrl(url, localStorage.getItem('hash'))
        .then(responseApi => {
          this.responseApis = responseApi;
          if(this.responseApis['success'] == false){
            this.router.navigate(['page-not-found']);
          }
          else{
            var domain = this.responseApis[0]['data']['generalDetails'][0]['has_domain'];
            var userListType = this.responseApis[0]['data']['generalDetails'][0]['user_list_type'];
            var hasUserList = this.responseApis[0]['data']['generalDetails'][0]['has_user_list'];

            this.policyTitle = this.responseApis[0]['data']['generalDetails'][0]['policy_title'];
            this.policyText = this.responseApis[0]['data']['generalDetails'][0]['policy'];

            this.instructionsTitle = this.responseApis[0]['data']['generalDetails'][0]['instructions_title'];
            this.instructionsText = this.responseApis[0]['data']['generalDetails'][0]['instructions'];

            if(domain == 1){
              this.domainList = this.responseApis[0]['data']['domains'];
            }
            else{
              this.domainList = false;
            }

            if(userListType == 'email'){
              this.userListType = true;
            }
            else{
              this.userListType = false;
            }

            if(hasUserList == 1){
              this.hasUserList = true;
            }
            else{
              this.hasUserList = false;
            }
            this.flagImage = this.responseApis[0].data.flag[0]['path']

            //has list - email
            if(this.hasUserList && this.userListType){
              this.form = new FormGroup({
                email: new FormControl('', validateEmail)
              });
            }

            //has list - no email, email not mandatory
            else if(this.hasUserList && !this.userListType){
              this.form = new FormGroup({
                identifier: new FormControl('', Validators.required),
                email: new FormControl('', validateEmail)
              });
            }

            // no list has a list of domains
            else if(!this.hasUserList && this.userListType && this.domainList != false){
              this.form = new FormGroup({
                identifier: new FormControl('', Validators.required),
                email: new FormControl(this.domainList[0].domain)
              });
            }

            //No list of users, no registered domains, no identifiers
            else if(!this.hasUserList && !this.domainList){
              this.form = new FormGroup({
                email: new FormControl('', validateEmail)
              });
            }

            else{
              this.router.navigate(['page-not-found']);
            }

            this.setBackgroundColor(this.responseApis[0]['data']['generalDetails'][0]['background_color']);
            this.backgroundColor = this.responseApis[0]['data']['generalDetails'][0]['background_color'];

            var questions= this.responseApis[0]['data']['questions'];
            for(var i = 0; i<questions.length; i++){
              if(questions[i]['order_in_quiz'] == parseInt(this.route.params['_value'].index)){
                this.currentQuestion = questions[i];
                this.orderInQuiz = questions[i]['order_in_quiz'];
              }
              if(questions[i]['order_in_quiz'] == parseInt(this.route.params['_value'].index) + 1){
                this.nextQuestion = questions[i]['order_in_quiz'];
              }
              if(questions[i]['order_in_quiz'] == parseInt(this.route.params['_value'].index) - 1){
                this.previousQuestion = questions[i]['order_in_quiz'];
              }
            }
            if(this.route.params['_value'].orientation == '1'){
              this.nextQuest = this.currentQuestion['order_in_quiz']+1;
            }
            else{
              this.nextQuest = this.currentQuestion['order_in_quiz']-1;
            }
            if(this.currentQuestion['question_id'] == -501){
              this.router.navigate([this.route.params['_value'].url+'/break/break1/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }
            if(this.currentQuestion['question_id'] == -502){
              this.router.navigate([this.route.params['_value'].url+'/break/break2/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }
            if(this.currentQuestion['question_id'] == -503){
              this.router.navigate([this.route.params['_value'].url+'/break/break3/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }
            if(this.currentQuestion['question_id'] == -504){
              this.router.navigate([this.route.params['_value'].url+'/break/break4/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }


            if(this.currentQuestion['question_id'] == -505){
              this.router.navigate([this.route.params['_value'].url+'/break/break5/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }
            if(this.currentQuestion['question_id'] == -506){
              this.router.navigate([this.route.params['_value'].url+'/break/break6/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }
            if(this.currentQuestion['question_id'] == -507){
              this.router.navigate([this.route.params['_value'].url+'/break/break7/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }


            if(this.currentQuestion['question_id'] == -508){
              this.router.navigate([this.route.params['_value'].url+'/break/break8/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }
            if(this.currentQuestion['question_id'] == -509){
              this.router.navigate([this.route.params['_value'].url+'/break/break9/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }
            if(this.currentQuestion['question_id'] == -510){
              this.router.navigate([this.route.params['_value'].url+'/break/break10/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }
            if(this.currentQuestion['question_id'] == -511){
              this.router.navigate([this.route.params['_value'].url+'/break/break11/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }


            if(this.currentQuestion['question_id'] == -512){
              this.router.navigate([this.route.params['_value'].url+'/break/break12/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }

            if(this.currentQuestion['question_id'] == -513){
              this.router.navigate([this.route.params['_value'].url+'/break/break13/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }

            if(this.currentQuestion['question_id'] == -514){
              this.router.navigate([this.route.params['_value'].url+'/break/break14/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }
            if(this.currentQuestion['question_id'] == -515){
              this.router.navigate([this.route.params['_value'].url+'/break/break15/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }
            if(this.currentQuestion['question_id'] == -516){
              this.router.navigate([this.route.params['_value'].url+'/break/break16/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }
            if(this.currentQuestion['question_id'] == -517){
              this.router.navigate([this.route.params['_value'].url+'/break/break17/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }
            if(this.currentQuestion['question_id'] == -518){
              this.router.navigate([this.route.params['_value'].url+'/break/break18/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }

            if(this.currentQuestion['question_id'] == -519){
              this.router.navigate([this.route.params['_value'].url+'/break/break19/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }

            if(this.currentQuestion['question_id'] == -520){
              this.router.navigate([this.route.params['_value'].url+'/break/break20/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }

            if(this.currentQuestion['question_id'] == -521){
              this.router.navigate([this.route.params['_value'].url+'/break/break21/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }

            if(this.currentQuestion['question_id'] == -522){
              this.router.navigate([this.route.params['_value'].url+'/break/break22/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }

            if(this.currentQuestion['question_id'] == -523){
              this.router.navigate([this.route.params['_value'].url+'/break/break23/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }

            if(this.currentQuestion['question_id'] == -524){
              this.router.navigate([this.route.params['_value'].url+'/break/break24/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }

            if(this.currentQuestion['question_id'] == -525){
              this.router.navigate([this.route.params['_value'].url+'/break/break25/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }

            if(this.currentQuestion['question_id'] == -526){
              this.router.navigate([this.route.params['_value'].url+'/break/break26/'+this.route.params['_value'].orientation+'/'+this.nextQuest]);
            }

            this.lengthOfQuiz = questions;
            if(this.route.params['_value'].index == 'policy'){
              this.instructions = false;
              this.policy = true;
              this.orderInQuiz = -1;
              this.nextQuestion = 'instructions';
              this.previousQuestion = 'policy';
            }
            else if(this.route.params['_value'].index == 'instructions'){
              this.instructions = true;
              this.policy = false;
              this.orderInQuiz = -1;
              this.nextQuestion = '1';
              this.previousQuestion = 'policy';
            }
            else if(this.orderInQuiz == 1){
              this.instructions = false;
              this.policy = false;
              this.previousQuestion = 'instructions';
            }
            else{
              this.instructions = false;
              this.policy = false;
            }

            var m = this;
            setTimeout(function(){
              m.showBigImageContainer = true;
              this.hideme = false;
              if(m.route.params['_value'].orientation == '1'){
                m.slideOut = false;
                m.slideOutRight = false;
                m.slideInRight = false;
                m.slideIn = true;
              }
              else{
                m.slideOut = false;
                m.slideOutRight = false;
                m.slideIn = false;
                m.slideInRight = true;
              }
            }, 1000);
            if(!this.hideFlag){
              setTimeout(function(){
                m.fadeOutLoader = true;
                setTimeout(function(){
                  m.logo = apiUrl + m.responseApis[0]['data']['logo'][0]['path'];
                }, 1000);
              }, 4000);
            }
            else{
              m.fadeOutLoader = true;
              m.logo = apiUrl + m.responseApis[0]['data']['logo'][0]['path'];
            }
          }

        })
        .catch(error => this.error = error);
    }
    else{
      this.router.navigate([this.route.params['_value'].url]);
    }

  }

  postAuthenticate(url: string, username:string): void {
    this.quizService
      .postAuthenticate(url, username)
      .then(responseApi => {
        this.loginAttempt = responseApi;
        var thing = this;
        this.fadeOutLoaderLogin = true;
        setTimeout(function(){

          thing.fadeOutLoaderLogin = false;
          thing.showLoaderLogin = false;
          thing.textError = thing.loginAttempt['msg'];
          localStorage.setItem('auth', thing.loginAttempt['token']);
          localStorage.setItem('hash', thing.loginAttempt['username']);
          //this.router.navigate(['page-not-found']);
        }, 1000);

      })
      .catch(error => this.error = error);
  }

  loginUser(){
    if(!this.form.valid){
      this.attemptToSubmit = false;
    }
    else{
      this.attemptToSubmit = true;
      var formValues = this.form.value;
      if(typeof formValues.identifier == 'undefined'){
        this.identifierForServer = formValues.email;
      }
      else{
        this.identifierForServer = formValues.identifier + '@' + formValues.email;
      }
      this.showLoaderLogin = true;
      this.textError = "";
      this.postAuthenticate(this.route.params['_value'].url, this.identifierForServer);
    }
  }

  markAnswer(elem:any){
  }
  passQuestion(elem:string){
    if(elem == 'forward'){
      this.slideIn = false;
      this.slideInRight = false;
      this.slideOutRight = false;
      this.slideOut = true;
      var m = this;
      setTimeout(function(){

        m.passToNextQuestion('1');
      }, 1000);
      //this.router.navigate([this.route.params['_value'].url+'/questionnaire/'+ this.nextQuestion]);
    }
    else{
      this.slideIn = false;
      this.slideInRight = false;
      this.slideOutRight = true;
      this.slideOut = false;
      var m = this;
      setTimeout(function(){
        m.passToNextQuestion('2');
      }, 1000);
    }
  }
  passToNextQuestion(orientation){

    if(orientation == 1){
      if(this.nextQuestion != false && this.nextQuestion != parseInt(this.route.params['_value'].index)){
        this.router.navigate([this.route.params['_value'].url+'/questionnaire/'+ this.nextQuestion + '/'+orientation+'']);
      }
      else{
        this.router.navigate([this.route.params['_value'].url+'/discover-profile']);
        //this.router.navigate([this.route.params['_value'].url+'/topic']);
      }
    }
    else{
      if(this.previousQuestion != false && this.previousQuestion != parseInt(this.route.params['_value'].index)){
        this.router.navigate([this.route.params['_value'].url+'/questionnaire/'+ this.previousQuestion + '/'+orientation+'']);
      }
    }
  }
  updateAnswer(elem:any){
    for(var i = 0; i< this.currentQuestion.question.answers.length; i++){
      this.currentQuestion.question.answers[i].checked = false;
    }
    elem.checked = true;
    this.quizService
      .updateAnswer(elem['question_id'], elem['id'], elem['rate'])
      .then(responseApi => {
        this.responseApis = responseApi;
        if(this.responseApis['success'] == false){
          this.router.navigate([this.route.params['_value'].url+'/login']);
        }
        else{

          this.slideIn = false;
          this.slideOut = true;
          var m = this;
          setTimeout(function(){
            m.passToNextQuestion('1');
            //m.getUrl(this.route.params['_value'].url);
          }, 1000);


        }

      })
      .catch(error => this.error = error);
  }

  ngOnInit(): void {
    this.showBigImageContainer = false;
    this.baseUrl = apiUrl;
    this.backgroundColor = '#ffffff'
    this.fadeOutLoader = false;
    this.logo = false;

    this.getUrl(this.route.params['_value'].url);

    if(this.route.params['_value'].index !='policy'){
      this.hideFlag = true;
    }
    else{
      this.hideFlag = false;
    }
    //console.log(document)
    //document.getElementById('bar-top').scrollIntoView();


    this.genericVal = this.route.params.subscribe(params => {
      const term = params['index'];
      this.getUrl(this.route.params['_value'].url);
      this.showBigImageContainer = false;
    });
  }
  logOut(){
    localStorage.clear();
    this.router.navigate([this.route.params['_value'].url]);
  }
}



// WEBPACK FOOTER //
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/quiz/quiz.component.ts